import React from 'react';
import { throttle } from 'lodash';
import { isResizeObserverSupported } from '../../../../../common/utils/is-resize-observable-supported';
export const useRemainingWidth = () => {
    const [maxWidth, setMaxWidth] = React.useState();
    const containerRef = React.useRef(null);
    const elementRef = React.useRef(null);
    React.useLayoutEffect(() => {
        if (containerRef.current && elementRef.current && isResizeObserverSupported()) {
            const observer = new ResizeObserver(throttle(([containerData]) => {
                const { width } = containerData.contentRect;
                const elementWidth = elementRef.current?.getBoundingClientRect().width ?? 0;
                setMaxWidth(width - elementWidth);
            }));
            observer.observe(containerRef.current);
            return () => {
                observer.disconnect();
            };
        }
    }, []);
    return { maxWidth, containerRef, elementRef };
};
//# sourceMappingURL=use-remaining-width.js.map